import {gsap} from "gsap/all";
import $ from "jquery";

// The game frame: buttons and info placed around the center screen (so they're not clipped by the morph mask).
export class GameFrame {

  constructor(selector = ".game-frame") {
    this.$el = $(selector);

    // The restart button only shows from step 2 on, so it's driven separately
    // rather than fading up with the rest of the frame.
    this.$restart = this.$el.find(".bottom-bar .pill-button");

    // Elements that fade up one at a time, in reveal (document) order.
    this.items = this.$el.find(".simulation-speed, .legend");
    this.timeline = null;

    // Start hidden
    gsap.set(this.$el, {autoAlpha: 0});
    gsap.set(this.$restart, {autoAlpha: 0});
  }

  show() {
    this.killTimeline();
    this.timeline = gsap.timeline();
    this.timeline.set(this.$el, {autoAlpha: 1});
    this.timeline.fromTo(this.items,
      {
        autoAlpha: 0,
        y: 16
      },
      {
        autoAlpha: 1,
        y: 0,
        duration: 0.4,
        ease: "power2.out",
        stagger: 0.3
      },
    );
  }

  hide() {
    this.killTimeline();
    this.timeline = gsap.to(this.$el, {
      autoAlpha: 0,
      duration: 0.3,
      ease: "power2.in"
    });
  }

  // Fade the restart button in (from step 2 on), with the same fade-up as the
  // rest of the frame items.
  showRestart() {
    gsap.fromTo(this.$restart,
      {
        autoAlpha: 0,
        y: 16
      },
      {
        autoAlpha: 1,
        y: 0,
        duration: 0.4,
        ease: "power2.out"
      });
  }

  // Hide the restart button (step 1). Instant on a reset, where the whole game is
  // being rebuilt behind the fade.
  hideRestart(instant = false) {
    gsap.to(this.$restart, {
      autoAlpha: 0,
      duration: instant ? 0 : 0.3,
      ease: "power2.in"
    });
  }

  killTimeline() {
    if (this.timeline) {
      this.timeline.kill();
      this.timeline = null;
    }
  }
}
